var $8799220e02769115$exports = {};
// Shows as many items as fit in `--overflow-list-lines` lines and hides the rest
// behind "+ More". Elm renders every item in both the row and the popover; this
// element only toggles `hidden`, so Elm re-renders never undo it.
//
// 1. It watches a zero-height sizer, not itself, so hiding items can't trigger
//    another resize.
// 2. Items are hidden from the end until "+ More" fits. If the first item alone
//    is too wide, `data-overflow-squeezed` truncates it instead.
// 3. An item cut off by its ellipsis also shows "+ More" so its full text can be
//    read. Its text is measured with a Range because scrollWidth is wrong for
//    buttons (focus ring) and for inline links in Firefox.
const $8799220e02769115$var$SIZER = ':scope > [data-overflow-sizer]';
const $8799220e02769115$var$ITEM = ':scope > [data-overflow-item]';
const $8799220e02769115$var$MORE = ':scope > [data-overflow-more]';
const $8799220e02769115$var$HIDDEN_ITEM = '[data-overflow-hidden-item]';
const $8799220e02769115$var$ENTRY = '[data-overflow-entry]';
const $8799220e02769115$var$SQUEEZED = 'data-overflow-squeezed';
function $8799220e02769115$var$lineIndexes(elements) {
    let line = -1;
    let lineBottom = -Infinity;
    return elements.map((element)=>{
        if (element.hidden) return -1;
        const { top: top, bottom: bottom } = element.getBoundingClientRect();
        if (top >= lineBottom - 1) {
            line += 1;
            lineBottom = bottom;
        }
        return line;
    });
}
function $8799220e02769115$var$isCutOff(item) {
    if (!item || item.hidden) return false;
    const entry = item.querySelector($8799220e02769115$var$ENTRY);
    if (!entry) return false;
    const text = document.createRange();
    text.selectNodeContents(entry);
    return text.getBoundingClientRect().width > entry.getBoundingClientRect().width + 1;
}
class $8799220e02769115$var$ElmOverflowList extends HTMLElement {
    connectedCallback() {
        this.resizeObserver = new ResizeObserver(([entry])=>{
            if (entry.contentRect.width !== this.sizerWidth) this.fit();
        });
        this.mutationObserver = new MutationObserver(()=>this.fit());
        this.mutationObserver.observe(this, {
            childList: true,
            subtree: true,
            characterData: true
        });
        document.fonts?.ready.then(()=>{
            if (this.isConnected) this.fit();
        });
        this.fit();
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
        this.mutationObserver.disconnect();
        this.observedSizer = undefined;
    }
    observe(sizer) {
        if (sizer === this.observedSizer) return;
        this.resizeObserver.disconnect();
        if (sizer) this.resizeObserver.observe(sizer);
        this.observedSizer = sizer;
    }
    fit() {
        const sizer = this.querySelector($8799220e02769115$var$SIZER);
        const more = this.querySelector($8799220e02769115$var$MORE);
        this.observe(sizer);
        if (!sizer || !more) return;
        this.sizerWidth = sizer.getBoundingClientRect().width;
        if (this.sizerWidth === 0) return;
        const items = Array.from(this.querySelectorAll($8799220e02769115$var$ITEM));
        const maxLines = parseInt(getComputedStyle(this).getPropertyValue('--overflow-list-lines'), 10) || 1;
        const overLimit = ()=>Math.max(-1, ...$8799220e02769115$var$lineIndexes([
                ...items,
                more
            ])) >= maxLines;
        this.removeAttribute($8799220e02769115$var$SQUEEZED);
        items.forEach((item)=>{
            item.hidden = false;
        });
        more.hidden = true;
        const lines = $8799220e02769115$var$lineIndexes(items);
        const overflowing = lines.length > 0 && lines[lines.length - 1] >= maxLines;
        if (overflowing) items.forEach((item, index)=>{
            if (index > 0 && lines[index] >= maxLines) item.hidden = true;
        });
        if (overflowing || items.some($8799220e02769115$var$isCutOff)) {
            more.hidden = false;
            for(let index = items.findLastIndex((item)=>!item.hidden); index > 0 && overLimit(); index -= 1)items[index].hidden = true;
            if (overLimit()) this.setAttribute($8799220e02769115$var$SQUEEZED, '');
        }
        this.querySelectorAll($8799220e02769115$var$HIDDEN_ITEM).forEach((entry, index)=>{
            entry.hidden = !(items[index]?.hidden || $8799220e02769115$var$isCutOff(items[index]));
        });
        if (more.hidden) more.querySelector('elm-popover')?.dispatchEvent(new Event('close'));
    }
}
if (!customElements.get('elm-overflow-list')) customElements.define('elm-overflow-list', $8799220e02769115$var$ElmOverflowList);


//# sourceMappingURL=project.7fb11146.js.map
